import { z } from 'zod'

export const ResolveLaneInputSchema = z.object({
  customerId: z.number().int().positive(),
  originLocationId: z.number().int().positive(),
  destinationLocationId: z.number().int().positive(),
})

export const CreateLaneShellInputSchema = z.object({
  customerId: z.number().int().positive(),
  originLocationId: z.number().int().positive(),
  destinationLocationId: z.number().int().positive(),
  description: z.string().max(255).optional(),
})
